/* Phone-only storefront policy. Checkout must also be protected by Shopify validation. */
(function () {
  'use strict';
  var tags = ['phone-to-order', 'call-to-order', 'phone-order-only'];
  var nativeFetch = window.fetch.bind(window);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var storageKey = 'pictureline-phone-order-notice';
  var queue = Promise.resolve();
  var notice;
  var allowedForms = new WeakSet();
  var knownVariants = new Map();
  var ready = document.readyState !== 'loading';

  function hasTag(product) {
    var values = product && product.tags || [];
    if (typeof values === 'string') values = values.split(',').map(function (v) { return v.trim(); });
    return values.some(function (tag) { return tags.indexOf(tag) !== -1; });
  }
  function message(titles, removed) {
    return titles.join('; ') + (removed ? ' was removed from your cart because it is available by phone only.' : ' is available by phone only and cannot be ordered online.');
  }
  function display(text, persist) {
    notice = text;
    if (persist) {
      try { sessionStorage.setItem(storageKey, JSON.stringify({ text: text, time: Date.now() })); } catch (_) { /* Storage may be disabled. */ }
    }
    if (!document.body) return;
    var box = document.getElementById('phone-order-notice');
    if (!box) {
      box = document.createElement('div');
      box.id = 'phone-order-notice';
      box.className = 'phone-order-notice';
      box.setAttribute('role', 'alert');
      box.setAttribute('aria-live', 'assertive');
      var paragraph = document.createElement('p');
      paragraph.className = 'phone-order-notice__message';
      box.appendChild(paragraph);
      var link = document.createElement('a');
      link.href = 'tel:8013641200';
      link.textContent = 'Call 801-364-1200 to order';
      box.appendChild(link);
      var dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.textContent = 'Dismiss';
      dismiss.addEventListener('click', function () {
        notice = null;
        box.remove();
        try { sessionStorage.removeItem(storageKey); } catch (_) { /* optional */ }
      });
      box.appendChild(dismiss);
      document.body.appendChild(box);
    }
    box.querySelector('p').textContent = text;
  }
  function refreshCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }
  async function policy() {
    var response = await nativeFetch(root + 'cart?view=phone-order-policy&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('Unable to check cart');
    var result = await response.json();
    if (!Array.isArray(result.items) || result.items.some(function (i) { return typeof i.restricted !== 'boolean' || !i.key; })) throw new Error('Invalid cart policy');
    return result.items;
  }
  async function cleanCart() {
    var items = await policy();
    var restricted = items.filter(function (i) { return i.restricted; });
    if (!restricted.length) return [];
    var updates = {};
    restricted.forEach(function (i) { updates[i.key] = 0; });
    var response = await nativeFetch(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates })
    });
    if (!response.ok) throw new Error('Unable to remove phone-only items');
    var result = await response.json();
    if (!Array.isArray(result.items)) throw new Error('Invalid cart response');
    // Confirm removal before telling the customer it happened. Never clear the whole cart.
    if (restricted.some(function (i) { return result.items.some(function (line) { return line.key === i.key; }); })) throw new Error('Phone-only items remain');
    var titles = Array.from(new Set(restricted.map(function (i) { return i.title; })));
    display(message(titles, true), true);
    refreshCart();
    return restricted;
  }
  function check() {
    // Serialize cleanup so simultaneous app/theme updates cannot remove stale line numbers.
    var task = queue.then(cleanCart);
    queue = task.catch(function () {});
    return task;
  }
  function failure() {
    display('We could not verify your cart. Please refresh the page and try again before checking out.', false);
  }
  function cartWrite(url) {
    try {
      var parsed = new URL(url, location.href);
      return parsed.origin === location.origin && /\/cart\/(add|change|update)(\.js)?\/?$/.test(parsed.pathname);
    } catch (_) { return false; }
  }
  window.fetch = async function (input, options) {
    var response = await nativeFetch(input, options);
    var url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    if (response.ok && cartWrite(url)) {
      try {
        var removed = await check();
        if (removed.length) {
          return new Response(JSON.stringify({ status: 422, message: 'Phone orders only', description: message(removed.map(function (i) { return i.title; }), true) + ' Call 801-364-1200 to order.' }), { status: 422, headers: { 'Content-Type': 'application/json' } });
        }
      } catch (_) { failure(); }
    }
    return response;
  };
  // Older apps use XMLHttpRequest rather than fetch. Inspect the resulting cart too.
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (cartWrite(url)) this.addEventListener('load', function () { check().catch(failure); }, { once: true });
    return open.apply(this, arguments);
  };
  function blockedForm(form) {
    var marker = form.querySelector('[data-phone-order-only]');
    var variant = form.querySelector('[name="id"]');
    return marker ? (marker.getAttribute('data-phone-order-title') || 'This item') : (variant && knownVariants.get(String(variant.value)));
  }
  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('button, input[type="submit"], a');
    if (!target || target.matches('[data-phone-order-only]')) return;
    var card = target.closest('[data-phone-order-card]');
    if (card && target.matches('.boost-sd__btn-add-to-cart, .boost-sd__button--add-to-cart')) {
      stop(event);
      var call = card.querySelector('[data-phone-order-title]');
      display(message([call ? call.getAttribute('data-phone-order-title') : 'This item'], false), false);
      return;
    }
    var form = target.closest('form[action*="/cart/add"]');
    if (form && (target.type === 'submit' || target.matches('[data-action="add-to-cart"]'))) {
      var title = blockedForm(form);
      if (title) { stop(event); display(message([title], false), false); return; }
    }
    if (target.matches('a[href]')) {
      var href = new URL(target.href, location.href);
      if (href.origin === location.origin && /\/checkout\/?$/.test(href.pathname)) {
        stop(event);
        check().then(function (removed) { if (!removed.length) location.assign(href.href); }).catch(failure);
      }
    }
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (allowedForms.has(form)) { allowedForms.delete(form); return; }
    if (form.matches('form[action*="/cart/add"]')) {
      var title = blockedForm(form);
      if (title) { stop(event); display(message([title], false), false); }
      return;
    }
    var submitter = event.submitter;
    if ((submitter && submitter.name === 'checkout') || /\/checkout\/?$/.test(new URL(form.action, location.href).pathname)) {
      stop(event);
      check().then(function (removed) {
        if (removed.length) return;
        allowedForms.add(form);
        form.requestSubmit(submitter || undefined);
      }).catch(failure);
    }
  }, true);
  function register(product) {
    if (!hasTag(product)) return false;
    (product.variants || []).forEach(function (variant) { knownVariants.set(String(variant.id), product.title || 'This item'); });
    return true;
  }
  window.PicturelinePhoneOrder = { hasTag: hasTag, register: register, check: check };
  function start() {
    ready = true;
    try {
      var saved = JSON.parse(sessionStorage.getItem(storageKey));
      if (saved && Date.now() - saved.time < 1800000) display(saved.text, false);
    } catch (_) { /* optional */ }
    if (notice) display(notice, false);
    check().catch(function () { /* A fresh check is required at checkout; browsing stays available. */ });
  }
  if (ready) start(); else document.addEventListener('DOMContentLoaded', start, { once: true });
  window.addEventListener('pageshow', function (event) { if (event.persisted) check().catch(failure); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden && ready) check().catch(function () {}); });
})();
